<template>
  <div class="rentalObject">
    <hl-Modal
      v-if="isErrorModalVisible"
      class="text-center"
      iconClass="budicon-cloud-server text-warning"
      title="Oops! Noe gikk galt. Vennligst prøv på nytt"
    >
      <div class="d-flex justify-content-center">
        <hl-Button class="d-flex items-center" :disabled="isLoading" @click="fetchRentalObject">
          <hl-LoaderDots v-if="isLoading" variant="white" class="mr-2" />
          Prøv igjen
        </hl-Button>
        <hl-Button variant="secondary" outline class="ml-3" @click="isErrorModalVisible = false"> Avbryt </hl-Button>
      </div>
    </hl-Modal>

    <PageLayout v-if="rentalObject">
      <router-view :defaultHeader="defaultHeader" />
    </PageLayout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLayout from '@/components/PageLayout.vue';
import Modal from '@modules/husleie-framework/src/components/modals/Modal.vue';
import LoaderDots from '@modules/husleie-framework/src/components/loaders/LoaderDots';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';

export default {
  name: 'RentalObject',

  components: {
    PageLayout,
    'hl-Modal': Modal,
    'hl-LoaderDots': LoaderDots,
    'hl-Button': Button,
  },

  props: {
    landlordId: [String, Number],
    rentalObjectId: [String, Number],
  },
  data() {
    return {
      isErrorModalVisible: false,
      headerStyleObject: {
        opacity: 1,
        transition: '.4s ease-in-out',
      },
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(['getRentalObject']),

    rentalObject() {
      return this.getRentalObject(this.rentalObjectId);
    },
    defaultHeader() {
      const { address, details } = this.rentalObject;

      if (details.alias) {
        return details.alias;
      }

      if (details.apartmentNumber) {
        return `${address.street} | ${details.apartmentNumber}`;
      }

      return address.street;
    },
  },
  methods: {
    changeRoute(r) {
      this.$router.push({ name: r });
    },
    async fetchRentalObject() {
      this.isLoading = true;

      try {
        await this.$store.dispatch('fetchRentalObject', {
          tenancies: ['active', 'free'],
          rentalObjectId: this.rentalObjectId,
        });
        this.isErrorModalVisible = false;
      } catch (error) {
        this.isErrorModalVisible = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchRentalObject();
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active {
  animation: bounceIn 0.8s;
}

@keyframes bounceIn {
  0% {
    transform: translate3d(0, 40px, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>

<style lang="scss">
// styling tables
.table {
  font-size: 0.9rem;
}

.table th,
.table td {
  border: none !important;
}

.table td {
  vertical-align: middle;
}

.action-menu-icon,
.help-icon {
  border: 1px solid $gray-200;
  text-align: center;
  padding: 10px;
  border-radius: 50%;
  display: inline-block;
  width: 30px;
  height: 30px;
  transition: 0.3s ease-in-out;
  cursor: pointer;

  span {
    letter-spacing: 2px;
    position: relative;
    top: -9px;
    left: -3px;
    font-size: 0.9rem;
    font-weight: 6700;
    color: $gray-800;
  }
}

.action-menu-icon:hover,
.help-icon:hover {
  box-shadow: $box-shadow-2;
  background: $gray-100;
  border: 1px solid $gray-500;
}

.help-icon span {
  top: -5px;
  left: 0px;
}
</style>
